/* eslint-disable
    no-unused-vars,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS205: Consider reworking code to avoid use of IIFEs
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
// @ts-expect-error TS(7006) FIXME: Parameter '$timeout' implicitly has an 'any' type.
const Syndetics = ($timeout, translationService) => ({
   replace: true,
   templateUrl: '/assets/syndetics.html',

   // optional attribute that lets us notify parent controller or directive when/if actual content exists from Syndetics
   scope: {
      // NOTE: changing 'isbn' value initiates the loading process; need to ensure that
      //       the element is being displayed before setting this val or syndetics will NOT
      //       update the placeholders properly.
      //       (i.e. upon initial view on preview pane - 2 sec delay; set isbn val when viewable)
      isbn: '@',
      clientId: '@',
      type: '@',
      view: '@',   // this needs to be the class name of an ancestor (i.e. preview, detailPage, etc.)
      contentLoaded: '=?'
   },

   link(s: any, el: any) {
      let loader: any = null

      s.i18n = translationService

      const push = function(arr: any) {
         return (function () {
            const result = []
            for (let i = 0; i < arguments.length; i++) {
               var arg = arguments[i]
               if (i > 0) {
                  result.push(arr.push(arg))
               }
            }
            return result
         })()
      }

      const generatePlaceholders = function(fields: any) {
         const a: any = []
         for (var field of fields) { a.push(`<div data-syndeticsid="${field}" class="syndetics-item ${field}"></div>`) }
         return a.join('')
      }

      // load data into directive when isbn value in the directive scope changes
      return s.$watch('isbn', function(newVal: any, oldVal: any, scope: any) {
      // cancel timeout call if isbn value changes before loader function completes
         if (loader) {
            $timeout.cancel(loader)
            loader = null
         }

         if (s.contentLoaded) {
            s.contentLoaded.loaded = false
         }

         const syndetics = $(el)
         syndetics.data('processed', false)
         const loading = syndetics.find('.syndetics-loading')
         const content = syndetics.find('.syndetics-content')

         // Hide content for use of this directive in context where isbn will be dynamic
         if ((newVal === "") || !s.clientId) {
            content.hide()
            content.empty()
            syndetics.hide()
            return 
         }

         // reset elements
         syndetics.show()
         loading.show()
         content.hide()
         content.empty()

         const loadSyndetics = function() {
            if (!syndetics.length || syndetics.data('processed')) { return }
            // mark as processed so we only request it once
            syndetics.data('processed', true)

            const isbn = $.trim(newVal)
            const fields = content.data('fields').split(' ')

            //  changing the $syndetics.callback method each time 'loadSyndetics' is fired was causing some odd behavior
            //  (callback method sometimes being called twice; once w/out jqXHR object);
            //  instead, use callback method and chain on to the ajax request (see syndetics.js) - dca
            const syndeticsFieldLabels: Record<string, string> = {
               syn_anotes: 'Author Notes',
               syn_awards: 'Awards',
               syn_blreview: 'Book List Review',
               syn_abreview: 'ABA Booknews Review',
               syn_chreview: 'Choice Review',
               syn_criticasreview: 'Criticas Review',
               syn_dbchapter: 'Excerpt',
               syn_gmsummary: 'Grade School & Middle School Summary',
               syn_hbreview: 'Horn Book Review',
               syn_itasummary: 'Italian Summary',
               syn_kireview: 'Kirkus Review',
               syn_ljreview: 'Library Journal Review',
               syn_nyreview: 'New York Times Review',
               syn_pwreview: "Publisher's Weekly Review",
               syn_sljreview: 'School Library Journal Review',
               syn_series: 'Series',
               syn_spreview: 'Spanish Preview',
               syn_spsummary: 'Spanish Summary',
               syn_summary: 'Summary',
               syn_swedreview: 'Swedish Review',
               syn_swedsummary: 'Swedish Summary',
               syn_swedtoc: 'Swedish Table of Contents',
               syn_toc: 'Table of Contents',
               syn_sptoc: 'Spanish Table of Contents',
               syn_fiction: 'Fiction Profile',
               syn_avprofile: 'Author/Video Profile',
               syn_avsummary: 'Audio/Video Summary',
               syn_video_clip: 'Video Clip',
            }

            const callback = function(data: any) {
               loading.hide()
               // hide syndetics element if nothing was added to divs
               if (content.find('div[data-syndeticsid]:empty').length === content.find('div[data-syndeticsid]').length) {
                  return syndetics.hide()
               } else {
                  // There can be mulitple instances of .syndetics-item on the page
                  // so we remove the id attr after its content is loaded
                  // but prior to display.
                  content.find('.syndetics-item').removeAttr('id').end().show()

                  // Fix accessibility: the Syndetics widget injects empty anchor tab links
                  // (e.g. <a href="#syn_anotes"></a>) with no discernible text.
                  // Add aria-label to any such anchors so screen readers can identify them.
                  content.find('a[href^="#syn_"]').each(function() {
                     const anchor = $(this)
                     if (!anchor.text().trim() && !anchor.attr('aria-label') && !anchor.attr('title')) {
                        const fieldId = (anchor.attr('href') || '').replace('#', '')
                        const label = syndeticsFieldLabels[fieldId]
                        if (label) {
                           anchor.attr('aria-label', label)
                        }
                     }
                  })

                  if (s.contentLoaded) {
                     // without this timeout, loaded attribute change is read very late by Angular
                     return $timeout(() => {
                        return s.contentLoaded.loaded = true
                     })
                  }
               }
            }

            // assign id's so syndetics can find them
            content
               .attr('id', 'syndetics-plus_' + s.$id)
               .append(generatePlaceholders(fields))
               .find('.syndetics-item').each(function() {
                  const item: any = $(this)
                  // The item's id must be set here so it can load its content, however,
                  // it is removed in the loadSyndetics callback to allow multiple
                  // instances in the app.
                  return item.attr('id', item.data('syndeticsid'))
               })

            // get syndetics id from scope
            // @ts-expect-error TS(2552) FIXME: Cannot find name '$syndetics'. Did you mean 'synde... Remove this comment to see the full error message
            $syndetics.id = scope.clientId
            // @ts-expect-error TS(2552) FIXME: Cannot find name '$syndetics'. Did you mean 'synde... Remove this comment to see the full error message
            $syndetics.isbn = isbn
            // @ts-expect-error TS(2552) FIXME: Cannot find name '$syndetics'. Did you mean 'synde... Remove this comment to see the full error message
            return $syndetics.enhance(syndetics, callback)
         }

         return loader = $timeout(loadSyndetics, 1000)
      })
   }
})

angular.module('summonApp.directives')
   .directive('syndetics', ['$timeout', 'translationService', Syndetics])
